export const getFileNameWithoutExtension = (filename: string): string =>
	filename.substring(0, filename.lastIndexOf('.docx')) || filename;
